var sizeSelectors = null;
var materialSelectors = null;
var productData = null;

function getSelectors() {
    var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    productData = jsonData['product'];
    productData['options'].forEach(function(option, index) {
        if (option == 'Size') {
            sizeSelectors = document.querySelectorAll('[name="option-' + index + '"]');
        }
        if (option == 'Material ID') {
            materialSelectors = document.querySelectorAll('[name="option-' + index + '"]');
        }
    });

    sizeSelectors.forEach((sizeSelector) => {
        sizeSelector.addEventListener('change', (event) => {
            var sizeSelectorValue = event.target.value;
            let possibles = [];
            productData['variants'].forEach((variant) => {
                if (variant.options.includes(sizeSelectorValue)) {
                    possibles.push(variant.options);
                }
            });
            var materialSelected = false;
            materialSelectors.forEach((materialSelector) => {
                const value = materialSelector.value;
                let flag = false;
                possibles.forEach((possible) => {
                    if (possible.includes(value)) {
                        flag = true;
                    }
                })
                if (flag === false) {
                    materialSelector.removeAttribute('checked');
                    materialSelector.setAttribute('disabled', 'disabled');
                } else {
                    materialSelector.removeAttribute('disabled');
                    if (!materialSelected) {
                        materialSelector.click();
                        materialSelected = true;
                    }
                }
            });
        });
    });
    materialSelectors[0].parentNode.parentNode.parentNode.style.display = 'none';
}

function updatePaintMaterial() {
    if (sizeSelectors == null && materialSelectors == null) {
        getSelectors();
    }
}